import type { SourceSystem } from 'graphql-models';
import { type Factory } from 'walden-fast/types/mocks';

const MOCK_SOURCESYSTEM: SourceSystem = {
  id: '1',
  entity: 'BOX',
  country: 'BE',
};

export const sourceSystemFactory: Factory<SourceSystem> = (overrides) => ({
  ...MOCK_SOURCESYSTEM,
  ...overrides,
});
